// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendMetadataForm = async (email: string): Promise<boolean> => {
  try {
    const formData = { email }
    if (window.Metadata && window.Metadata.siteScript) {
      window.Metadata.siteScript.sendData(formData)
      return true // Successfully sent data
    } else {
      return false // Metadata script not loaded or available
    }
  } catch (error) {
    return false // Error occurred while sending data
  }
}
